// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Login-card {\n    width: 400px;\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 20vh;\n    margin: 0 auto;\n}\n\n@media only screen and (max-width: 800px) {\n    .Login-card {\n        height: 100%;\n        top: 0;\n        width: 100%;\n        border: 0;\n    }\n}\n\n", ""]);
// Exports
module.exports = exports;
